module.exports = __webpack_public_path__ + "img/heading_uk.1891f7a6.svg";